"use client";

import Link from "next/link";
import { useState, type ComponentProps } from "react";

export type HoverPrefetchLinkProps = Omit<ComponentProps<typeof Link>, "prefetch">;

export function HoverPrefetchLink({
  onMouseEnter,
  onTouchStart,
  onFocus,
  ...props
}: HoverPrefetchLinkProps) {
  const [isArmed, setIsArmed] = useState(false);
  const arm = () => setIsArmed(true);

  return (
    <Link
      {...props}
      prefetch={isArmed ? undefined : false}
      onMouseEnter={(event) => {
        arm();
        onMouseEnter?.(event);
      }}
      onTouchStart={(event) => {
        arm();
        onTouchStart?.(event);
      }}
      onFocus={(event) => {
        arm();
        onFocus?.(event);
      }}
    />
  );
}
